import React, { useState, useEffect } from "react";
import { Prompt } from "react-router-dom";
import * as recipeApi from "../api/recipes";
import { getFoodList } from "../api/food";
import { toast } from "react-toastify";
import TextInput from "./common/TextInput";
import DropDown from "./common/DropDown";
import Select from 'react-select'

function RecipePage(props) {
    const [recipe, setRecipe] = useState({
        name: "",
        mealTime: 1,
        recipeFood: []
    });
    const [food, setFood] = useState([]);
    const [preventRedirect, setPreventRed] = useState(false);
    const [saved, setSaved] = useState(false);
    const [selectedFood, setSelectedFood] = useState(null);

    useEffect(() => {
        const recipeId = props.match.params.recipeId;
        if (recipeId) {
            (async () => {
                try {
                    let editedRecipe = await recipeApi.getRecipe(recipeId);
                    setRecipe(editedRecipe);
                    setFood(await getFoodList());
                } catch {
                    toast.error("Error al obtener receta");
                }
            })();
        }

        (async () => {
            try {
                setFood(await getFoodList());
            } catch {
                toast.error("Error al obtener lista de alimentos");
            }
        })();
    }, []); //if the second par of useEffect is an empty array, it will only execute one time when mounting the component

    useEffect(
        () => {
            if (saved) props.history.push("/Recipes"); //redirects to recipes
        },
        [saved]
    ); //it will only execute when saved is modified

    function handleSelected(food) {
        if (food)
            setSelectedFood(food);
        else
            setSelectedFood(null);
    }

    function handleChange(
        event,
        dataType = "",
        objName = event.target.id,
        value = event.target.value,
        isValid = true
    ) {
        if (dataType === "check") value = event.target.checked;
        else if (dataType === "select") value = Number(event.target.value);

        const updatedRecipe = { ...recipe, [objName]: value };
        setRecipe(updatedRecipe);
        setPreventRed(true);
    }

    async function handleSave(event) {
        event.preventDefault();
        try {
            if (recipe.id) {
                await recipeApi.updateRecipe(recipe.id, recipe);
            } else {
                await recipeApi.addRecipe(recipe);
            }
            setPreventRed(false);
            setSaved(true);
            toast.success("Receta guardada exitosamente");
        } catch (error) {
            toast.error("Hubo un error al guardar");
        }
    }

    async function handleFoodRemoved(foodId) {
        try {
            //if (window.confirm("Estas seguro?")) {
            var array = [...recipe.recipeFood]; // make a separate copy of the array
            var index = array.findIndex(f => f.foodId === foodId);
            if (index !== -1) {
                array.splice(index, 1);
                setRecipe({ ...recipe, recipeFood: array });
                //toast.success("Receta borrada exitosamente");
            }
            //}
        } catch {
            toast.error("Hubo un error al borrar la receta");
        }
    }

    return (
        <>
            <h2>Recipe</h2>
            <Prompt
                when={preventRedirect}
                message="Estas seguro que deseas abandonar esta pagina sin guardar tus cambios?"
            />
            <form onSubmit={handleSave}>
                <TextInput id="name" label="Nombre" value={recipe.name} onChange={handleChange} />
                <DropDown id="mealTime" label="Tiempo" value={recipe.mealTime} onChange={handleChange} list={[
                    { "id": 1, "text": "Desayuno" },
                    { "id": 2, "text": "Comida" },
                    { "id": 3, "text": "Cena" },
                    { "id": 4, "text": "Colacion" },
                    { "id": 5, "text": "Colacion 2" }
                ]} />
                <div className="row mb-2">
                    <label className="col-sm-3 col-lg-2 col-form-label">Agrega alimentos:</label>
                    <div className="col-sm-7 col-lg-6">
                        <Select options={food} isClearable="true" isSearchable="true" placeholder="Buscar..." onChange={handleSelected} />
                    </div>
                    <div className="col-sm-1 col-lg-1">
                        <input
                            type="button"
                            className="btn btn-primary"
                            value="Agregar"
                            onClick={() => {
                                if (selectedFood) {
                                    let foodList = [
                                        ...recipe.recipeFood,
                                        {
                                            foodId: selectedFood.value,
                                            name: selectedFood.label,
                                            isEssential: false
                                        }
                                    ];
                                    setRecipe({ ...recipe, recipeFood: foodList });
                                }
                                else
                                    toast.error("No hay ningun alimento seleccionado");
                            }}
                        />
                    </div>
                </div>
                <table className="table">
                    <thead className="table-dark">
                        <tr>
                            <th>Alimentos</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                        {recipe.recipeFood.map(food => {
                            return (
                                <tr key={food.foodId}>
                                    <td>{food.name}</td>
                                    <td>
                                        <input
                                            type="button"
                                            onClick={event => handleFoodRemoved(food.foodId)}
                                            className="btn btn-danger btn-sm"
                                            value="Borrar"
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <input type="submit" value="Guardar" className="btn btn-primary" />
            </form>
        </>
    );
}

export default RecipePage;
